<template>
  <div class="wrapper">
    <div class="content">
      <img
        v-if="photoSrc && !photoError"
        :src="photoSrc"
        :alt="fullName"
        class="rounded-xl border border-border object-cover flex items-center justify-center"
        style="width: 72px; height: 88px"
        @error="photoError = true"
      />
      <div v-else class="empty">
        <svg-icon name="huge-user" class="w-6 h-16 text-muted-foreground" />
      </div>

      <div class="data">
        <p class="name" :title="fullName || $t('Не указано')">
          {{ fullName || $t("Не указано") }}
        </p>

        <div class="flex items-center gap-2">
          <p class="text-sm text-foreground">
            {{ identifier || $t("Не указано") }}
          </p>

          <button
            v-if="identifier"
            @click.stop="copyIin(identifier)"
            class="text-muted-foreground"
          >
            <svg-icon name="huge-copy" class="w-4 h-4" />
          </button>
        </div>

        <p class="text-sm font-medium text-muted-foreground">
          {{ formatDate(client.created_at) }}
        </p>
      </div>
    </div>

    <!--    <div class="footer">-->
    <!--      <Checkbox v-model="selectClient">-->
    <!--        <span class="label"> {{ $t("Выбрать клиента") }} </span>-->
    <!--      </Checkbox>-->

    <!--      &lt;!&ndash;      <button class="card" @click="$emit('select', client.uuid)">&ndash;&gt;-->
    <!--      &lt;!&ndash;        <p class="text-sm leading-6 text-muted-foreground">&ndash;&gt;-->
    <!--      &lt;!&ndash;          {{ $t("Карточка клиента") }}&ndash;&gt;-->
    <!--      &lt;!&ndash;        </p>&ndash;&gt;-->
    <!--      &lt;!&ndash;      </button>&ndash;&gt;-->

    <!--      <Button-->
    <!--        variant="outline"-->
    <!--        @click="$emit('select', client.uuid)"-->
    <!--        class="text-sm text-muted-foreground"-->
    <!--      >-->
    <!--        {{ $t("Карточка клиента") }}-->
    <!--      </Button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Checkbox from "@/shared/ui/checkbox/Checkbox.vue";
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";
import Button from "../../../shared/ui/button/Button.vue";
import dateFormat from "@/shared/lib/date-format";
import { useAuthedImage } from "@/shared/lib/composables/useAuthedImage";

export default {
  name: "ClientCard",
  components: { Button, SvgIcon, Checkbox },
  props: {
    client: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  setup(props) {
    const { src: photoSrc, error: photoError } = useAuthedImage(
      () => props.client.person_photo
    );
    return { photoSrc, photoError };
  },
  data() {
    return {
      selectClient: false,
      copyTimeout: null,
    };
  },
  computed: {
    isLegal() {
      return this.client.participant_type === "LEGAL";
    },
    fullName() {
      if (this.isLegal) {
        return this.client.params?.company_name || this.client.name || "";
      }
      const { last_name, first_name, middle_name, name } = this.client;
      if (last_name || first_name) {
        return [last_name, first_name, middle_name].filter(Boolean).join(" ");
      }
      return name || "";
    },
    identifier() {
      return this.client.iin || this.client.identifier || "";
    },
  },
  methods: {
    async copyIin(text) {
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
        if (!this.copyTimeout) {
          this.$message.success(this.$t("Скопировано"));
          this.copyTimeout = setTimeout(() => {
            this.copyTimeout = null;
          }, 3000);
        }
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },
    formatDate(date) {
      if (!date) return this.$t("Не указано");
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm");
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  @apply flex flex-col p-4 gap-4;
  @apply bg-card border border-solid border-border;
  border-radius: var(--radius);

  .content {
    @apply flex items-center gap-5 self-stretch;

    .data {
      @apply flex flex-col justify-center items-start gap-1 self-stretch;

      .name {
        @apply font-medium text-foreground line-clamp-2 leading-5;
        font-size: 15px;
      }
    }
  }

  .footer {
    @apply flex justify-between items-center self-stretch;

    .label {
      @apply text-sm pl-[2px] font-medium cursor-pointer text-foreground;
    }
    .card {
      @apply h-10 flex justify-center items-center py-1 px-[10px] gap-[2px];
      @apply rounded-[30px] bg-card outline-none cursor-pointer border border-border;
      box-shadow: 0 2px 3px 0 rgba(255, 255, 255, 0.03) inset,
        0 2px 1.5px -0.5px rgba(0, 0, 0, 0.03);
      transition: all 0.2s;

      &:hover {
        @apply bg-gray-500;

        p {
          @apply text-white;
        }
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }
}

.empty {
  @apply min-w-[72px] h-[88px] flex justify-center items-center bg-muted/50;
  @apply rounded-xl border border-border;
}
</style>
